/**
 * 播免费拿相关页面
 */
const boActivityRouter = [
  {
    path: '/bo/activity',
    component: () => import('@/views/bo-activity'),
    name: 'BoActivity',
    meta: { title: '免费拿产品详情', auth: false },
  },
  {
    path: '/bo/rules',
    component: () => import('@/views/bo-activity/rules'),
    name: 'BoRules',
    meta: { title: '活动规则', auth: false },
  },
  {
    path: '/bo/success',
    component: () => import('@/views/bo-activity/success'),
    name: 'BoSuccess',
    meta: { title: '传播礼-成功拿礼', auth: false },
  },
  {
    path: '/bo/address',
    component: () => import('@/views/bo-activity/address'),
    name: 'BoAddress',
    meta: { title: '免费拿邮寄-填写地址', auth: false },
  },
];

export default boActivityRouter;
